<div class="row align-items-center">
  <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
    <span class="description" *ngIf="pagination.numResults > 0">
      Exibindo {{firstElement | number}} a {{lastElement  | number}} de {{pagination.numResults | number}} resultados
    </span>
    <span class="description" *ngIf="pagination.numResults == 0" [translate]="'painel-dashboard/no-results'">
      Nenhum resultado encontrado.
    </span>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    <nav class="navigation pagination" aria-label="navigation" *ngIf="maxPage > 0">

      <ul class="pagination">
        <li class="page-item" *ngIf="(pagination.page > 0)">
          <a class="page-link" (click)="setPage(pagination.page-1)">
            <i class="fa fa-angle-left"></i>
          </a>
        </li>

        <li class="page-item" *ngFor="let pageIdx of pageIdxs">

          <a class="page-link" (click)="setPage(pageIdx)" *ngIf="pagination.page != pageIdx">{{pageIdx + 1}}</a>
          <span *ngIf="pagination.page == pageIdx" class="page-link">{{pageIdx + 1}}</span>
        </li>
        <li class="page-item" *ngIf="pagination.page < maxPage">
          <a class="page-link" (click)="addPage(pagination.page)">
            <i class="fa fa-angle-right"></i>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>